import { queryOptions } from "@tanstack/react-query";

import API, { unwrapApiResult } from "~/api";
import { resolveReportArtifactUrl } from "~/features/surveys/lib/resolve-report-artifact-url";

export const surveyKeys = {
  all: ["surveys"] as const,
  lists: () => [...surveyKeys.all, "list"] as const,
  details: () => [...surveyKeys.all, "detail"] as const,
  detail: (uuid: string) => [...surveyKeys.details(), uuid] as const,
  report: (uuid: string) => [...surveyKeys.detail(uuid), "report"] as const,
};

export const getSurveysListQueryOptions = () =>
  queryOptions({
    queryKey: surveyKeys.lists(),
    queryFn: async () => {
      const result = await unwrapApiResult(API.survey.getSurveys());
      return result.data;
    },
  });

export const getSurveyDetailQueryOptions = (uuid: string) =>
  queryOptions({
    queryKey: surveyKeys.detail(uuid),
    queryFn: async () => {
      const result = await unwrapApiResult(API.survey.getSurveyDetail(uuid));
      return result.data;
    },
    enabled: Boolean(uuid),
  });

export const getSurveyReportQueryOptions = (uuid: string) =>
  queryOptions({
    queryKey: surveyKeys.report(uuid),
    queryFn: async ({ signal }) => {
      const result = await unwrapApiResult(API.survey.getPDFReport(uuid, signal));
      return resolveReportArtifactUrl(result.data?.url);
    },
    enabled: Boolean(uuid),
  });
